import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '@draeger-academy/common';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { ShowMoreModule } from '../show-more';
import { ContentSectionComponent } from './content-section.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ContentSectionComponent],
    imports: [
        CommonModule,
        PipesModule,
        DaLinkModule,
        DaButtonModule,
        DaProgressiveImageModule,
        ShowMoreModule,
        TranslateModule
    ],
    providers: [],
    exports: [ContentSectionComponent]
})
export class ContentSectionModule {
    constructor() {}
}
